import { render } from "./ContentDetailsModal.vue?vue&type=template&id=0a48e7b3"
import script from "./ContentDetailsModal.vue?vue&type=script&lang=js"
export * from "./ContentDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__